import { StateCreator } from 'zustand';

export type ModalsState = {
  showModalUnderstandBetterOmnichannel: boolean;
  showModalSpeakWithSpecialistOmnichannel: boolean;
  showModalPriceSources: boolean;
  showModalOmnichannelSaveFilters: boolean;
  showModalOmnichannelDeleteFilters: boolean;
};

export const modalsInitialState: ModalsState = {
  showModalUnderstandBetterOmnichannel: false,
  showModalSpeakWithSpecialistOmnichannel: false,
  showModalPriceSources: false,
  showModalOmnichannelSaveFilters: false,
  showModalOmnichannelDeleteFilters: false,
};

export const createModalsSlice: StateCreator<ModalsState> = () => ({
  ...modalsInitialState,
});
